import { render, staticRenderFns } from "./editor.vue?vue&type=template&id=121da039&scoped=true"
import script from "./editor.vue?vue&type=script&lang=js"
export * from "./editor.vue?vue&type=script&lang=js"
import style0 from "./editor.vue?vue&type=style&index=0&id=121da039&prod&lang=scss&scoped=true"
import style1 from "./editor.vue?vue&type=style&index=1&id=121da039&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "121da039",
  null
  
)

export default component.exports